module.exports = __webpack_public_path__ + "img/011-feeder.9a700779.png";